import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql-types'

const defaultOptions = {} as const
export type GetAccountPreferenceCenterUrlQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type GetAccountPreferenceCenterUrlQuery = { __typename?: 'Query', userInfoCurrent?: { __typename?: 'UserInfoCurrentResponse', userInfo?: { __typename?: 'UserInfo', preferenceCenterUrl?: string | null } | null } | null };

export const GetAccountPreferenceCenterUrlDocument = gql`
    query GetAccountPreferenceCenterUrl {
  userInfoCurrent {
    userInfo {
      preferenceCenterUrl
    }
  }
}
    `

/**
 * __useGetAccountPreferenceCenterUrlQuery__
 *
 * To run a query within a React component, call `useGetAccountPreferenceCenterUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPreferenceCenterUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPreferenceCenterUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountPreferenceCenterUrlQuery (baseOptions?: Apollo.QueryHookOptions<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>(GetAccountPreferenceCenterUrlDocument, options)
}
export function useGetAccountPreferenceCenterUrlLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>(GetAccountPreferenceCenterUrlDocument, options)
}
export function useGetAccountPreferenceCenterUrlSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>(GetAccountPreferenceCenterUrlDocument, options)
}
export type GetAccountPreferenceCenterUrlQueryHookResult = ReturnType<typeof useGetAccountPreferenceCenterUrlQuery>;
export type GetAccountPreferenceCenterUrlLazyQueryHookResult = ReturnType<typeof useGetAccountPreferenceCenterUrlLazyQuery>;
export type GetAccountPreferenceCenterUrlSuspenseQueryHookResult = ReturnType<typeof useGetAccountPreferenceCenterUrlSuspenseQuery>;
export type GetAccountPreferenceCenterUrlQueryResult = Apollo.QueryResult<GetAccountPreferenceCenterUrlQuery, GetAccountPreferenceCenterUrlQueryVariables>;
